import { QuestionStatus } from '@exam-management/graphql';
import { z } from 'zod';

export const FinishQuestionReviewMainTaskFormSchema = z.object({
  questions: z.record(
    z.string(),
    z.enum([QuestionStatus.Draft, QuestionStatus.Disabled, QuestionStatus.PreDraft]),
  ),
});

export type FinishQuestionReviewMainTaskFormInput = z.infer<
  typeof FinishQuestionReviewMainTaskFormSchema
>;
